import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Items/Navbar';
import AuthContext from '../shared/AuthContext';
import PageMeta from '../seo/PageMeta';
import apiClient from '../shared/hooks/AuthService';

export default function CheckoutSuccessPage() {
  const { user } = useContext(AuthContext);
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    apiClient.get('/api/users/me/usage').then((r) => setUsage(r.data)).catch(() => {});
  }, []);

  const demo = new URLSearchParams(window.location.search).get('demo') === '1';

  return (
    <div>
      <PageMeta title="Upgrade successful" description="Your QnaRead plan was updated" />
      <Navbar userProfile={user} loading={false} />
      <main className="checkout-result-shell">
        <div className="checkout-result-card">
          <h1>You're all set{demo ? ' (demo)' : ''}</h1>
          <p>
            {usage?.plan === 'PRO'
              ? 'Pro is active — higher AI limits and priority features are unlocked.'
              : 'Payment received. Your plan will update within a minute if webhook processing is pending.'}
          </p>
          <p style={{ color: '#64748b', fontSize: 14 }}>
            Current plan: <strong>{usage?.plan || 'Updating…'}</strong>
          </p>
          <div className="checkout-result-actions">
            <Link to="/library" className="home-btn home-btn-primary">Go to dashboard</Link>
            <Link to="/settings" className="home-btn home-btn-secondary">Settings</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
